"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCatalogueItems = void 0;
/**
 * Allows you to completely remove multiple catalogue items from the database.
 */
var deleteCatalogueItems = function (instance) {
    return function (id, body, config) {
        return instance.delete("/catalogues/".concat(id, "/items"), __assign({ data: body }, config));
    };
};
exports.deleteCatalogueItems = deleteCatalogueItems;
